import { Button, css, styled, Typography } from '@mui/material';
import MUITypography from '@mui/material/Typography';
import { device } from 'src/constants/mediaQueries';

/* istanbul ignore next */
export const SectionSpacing = styled('div')`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: auto;
  gap: 1rem ${({ theme }) => theme.breakpoints.up('md')} {
    gap: 2rem;
  }
  ${({ theme }) => theme.breakpoints.up('lg')} {
    gap: 4rem;
  }
`;
export const HeaderText = styled(MUITypography)`
  ${({ theme }) => css`
    font-size: ${theme.typography.h6.fontSize};
    font-weight: ${theme.typography.h1.fontWeight};
    @media only screen and ${device.mobileOrTablet} {
      font-size: ${theme.typography.body1.fontSize};
    }
  `}
`;

export const NumberCircled = styled(Typography)`
  font-weight: bold;
  height: 40px;
  width: 40px;
  text-align: center;
  border-radius: 50%;
  line-height: 24px;
  padding: 0.4rem;
  border: 2px solid ${({ theme }) => theme.palette.grey[900]};
  font-size: ${({ theme }) => theme.typography.body2.fontSize};

  ${({ theme }) => theme.breakpoints.up('md')} {
    font-size: ${({ theme }) => theme.typography.body1.fontSize};
  }
`;

export const DownloadTemplateButton = styled(Button)`
  ${({ theme }) => css`
    font-size: ${theme.typography.body1.fontSize};
    font-weight: ${theme.typography.h1.fontWeight};
    @media only screen and ${device.mobileOrTablet} {
      font-size: ${theme.typography.body2.fontSize};
    }
  `};
  text-transform: unset;
  background-color: black;
  gap: 1rem;
  &:hover {
    background-color: ${({ theme }) => theme.palette.secondary.light};
  }
`;

export const UploadSection = styled('div')`
  max-width: 36rem;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: start;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const FooterAction = styled(Button)`
  text-transform: unset;
  ${({ theme }) => css`
    font-size: ${theme.typography.body2.fontSize};
    background-color: ${theme.palette.secondary.main};

    &:hover {
      background-color: ${theme.palette.secondary.light};
    }
  `};

  ${({ theme }) => theme.breakpoints.up('md')} {
    ${({ theme }) => css`
      font-size: ${theme.typography.body1.fontSize};
      font-weight: ${theme.typography.h1.fontWeight};
    `};
  }

  .MuiButton-endIcon {
    margin-left: 1rem;
  }
`;
